import React, { useEffect, useState } from 'react';
import InicioSlider from './InicioSlider';
import WeatherProducts from './WeatherProducts';
import OfferGrid from './OfferGrid';
import ServicesSection from './ServicesSection';
import AIProductsSection from './AIProductsSection';
import AIChatSection from './AIChatSection';
import SEO from '../shared/SEO';
import { ConfigContext } from '../../providers/ConfigContext';

const Inicio = () => {
  const [homeContent, setHomeContent] = useState(null);
  const [weatherEnabled, setWeatherEnabled] = useState(true);
  const { config } = React.useContext(ConfigContext);

  useEffect(() => {
    const loadHomeContent = async () => {
      try {
        const [contentRes, storeRes] = await Promise.all([
          fetch(`${process.env.REACT_APP_API_URL}/home-content`),
          fetch(`${process.env.REACT_APP_API_URL}/store-config`)
        ]);
        const contentData = await contentRes.json();
        const storeData = await storeRes.json();

        if (contentRes.ok && contentData.success) {
          setHomeContent(contentData.data);
        }
        if (storeRes.ok && storeData.success) {
          setWeatherEnabled(storeData.data?.weatherEnabled !== false);
        }
      } catch (error) {
        console.error('Error loading home content:', error);
      }
    };

    loadHomeContent();
  }, []);

  return (
    <>
      <SEO
        title="Moda Femenina — Tienda Online"
        description={`${config?.brand?.name || 'E-MOREIRA'} — Tu tienda online de moda femenina. Descubrí las últimas tendencias en vestidos, tops, pantalones y accesorios. Envíos a todo Uruguay.`}
        url="/"
        type="website"
      />
      <div id="inicio">
        <header>
          {homeContent === null ? (
            <div style={{
              width: '100%',
              height: 'calc(100vh - 100px)',
              minHeight: '500px',
              maxHeight: '900px',
              background: '#1a1a1a'
            }} />
          ) : (
            <InicioSlider
              enabled={homeContent?.slider?.enabled}
              slides={homeContent?.slider?.slides}
            />
          )}
        </header>
        <main>
          {weatherEnabled && <WeatherProducts />}
          <OfferGrid featuredCategories={homeContent?.featuredCategories} />
          <AIProductsSection
            enabled={homeContent?.featuredProducts?.enabled}
            featuredProducts={homeContent?.featuredProducts?.items}
          />
          <ServicesSection services={homeContent?.services} />
          <AIChatSection />
        </main>
      </div>
    </>
  );
};

export default Inicio;
